import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import Sidebar from '../Sidebar/Sidebar';

const Window = styled.div`
  flex: 1 1 auto;
  padding-left: 30px;
  padding-right: 25px;
  overflow-y: auto;

  @media print {
    margin-left: 5%;
    margin-right: 5%;
    width: 100%;
    overflow-y: show;
  }
`;

const Main = styled.div`
  display: flex;
  height: 100vh;
  @media print {
    height: auto;
  }
`;

function _MainWindow(props: {
  page: string;
  business: Business;
  wide?: boolean;
  children?: JSX.Element | Array<JSX.Element>;
}) {
  return (
    <Main>
      <Sidebar page={props.page} />
      {props.business.id && <Window wide={props.wide}>{props.children}</Window>}
    </Main>
  );
}

const MainWindow = connect(({ business }: any) => ({ business }))(_MainWindow);

export default MainWindow;

export const testWindow = (Component, page) => (props) => (
  <MainWindow page={page}>{<Component {...props} />}</MainWindow>
);
